class PredictiveSearchCities extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchCitiesResults = this.querySelector('#predictive-search-cities');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=page&section_id=predictive-search-cities`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-cities').innerHTML;
        this.predictiveSearchCitiesResults.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  close() {
    this.predictiveSearchCitiesResults.innerHTML = "<div x-init=\"() => result = null\"></div>";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search-cities', PredictiveSearchCities);
